import { Component, OnInit } from '@angular/core';

import { first } from 'rxjs/operators';

import { AuthService } from './auth/services/auth.service';

import * as _ from 'lodash';
import * as moment from 'moment';
import * as numeral from 'numeral';
import 'numeral/locales/pt-br';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'survey-check-web';

  constructor(
    private authService: AuthService,
  ) { }

  ngOnInit(): void {
    // Defines the date format to pt-BR.
    moment.locale('pt-BR');

    // Defines the number format to pt-BR.
    numeral.locale('pt-br');

    // Definition for validateAccessToken to authenticate user when page was reloaded.
    if (this.authService.getAccessToken() !== null) {
      this.authService.validateAccessToken()
        .pipe(first()).subscribe();
    }
  }
}
